/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFooterFragment} from '@amblique/contentful/app/contentful/fragments/footer/base-footer.fragment';
import {FooterColumnFragment} from '@amblique/contentful/app/contentful/fragments/footer-column/footer-column.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';

export const FullFooterFragment = gql`
  ${BaseFooterFragment}
  ${FooterColumnFragment}
  ${ImageFragment}
  ${LinkFragment}

  fragment FullFooterFragment on Footer {
    ...BaseFooterFragment

    columnsCollection {
      items {
        __typename
        ... on FooterColumn {
          ...FooterColumnFragment
        }
      }
    }
    countriesCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
    logo {
      ...ImageFragment
    }
    paymentsCollection {
      items {
        __typename
        ... on Entry {
          sys {
            id
          }
        }
      }
    }
    socialLinksCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
  }
`;
